import { Link } from 'react-router-dom';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

// العمولة is built and routed at /commission, but kept out of this list so it
// does not show on the landing page yet.
const services = [{ label: 'خدمات رقمية', path: '/digital-services' }];

const Index = () => {
	// Column layout so a short page still pins the footer to the bottom of the
	// viewport, while a long one lets it fall below the fold.
	return (
		<div className="flex min-h-screen flex-col" style={{ backgroundColor: '#e6e6b8' }}>
			<div className="top-0 z-10000 w-full px-0 py-3 sm:p-6">
				<Navbar />
			</div>

			<section className="container mx-auto flex-1 px-4 pb-16 pt-10 sm:pt-16">
				{/* Brand plate: the dotted yellow rule sits inset from the green edge,
				    so it is an inner box rather than a border on the plate itself. */}
				<div className="text-center">
					<div
						className="inline-block w-full max-w-[300px] rounded-[30px] p-1.5 sm:max-w-[340px]"
						style={{ backgroundColor: '#1b5e20', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
						<div
							className="rounded-[26px] px-5 py-6 text-3xl font-extrabold sm:px-8 sm:py-7 sm:text-4xl"
							style={{ border: '3px dotted #ffd600', color: '#ffd600' }}>
							جبر الخواطر
						</div>
					</div>
				</div>

				<p
					className="mx-auto mt-14 max-w-[560px] text-center text-2xl font-bold sm:mt-20 sm:text-[32px]"
					style={{ color: '#1b5e20', lineHeight: '1.9' }}>
					هي منصة جزائرية 100% ومؤسسها هو محادي جنيدي وتحتوي على مايلي :
				</p>

				<div className="mt-14 flex flex-col items-center gap-5 sm:mt-20">
					{services.map((service) => (
						<Link key={service.path} to={service.path} className="w-full max-w-[380px]">
							<div
								className="w-full cursor-pointer rounded-[8px] px-6 py-5 text-center text-2xl font-bold transition-transform hover:-translate-y-0.5 sm:text-[28px]"
								style={{ backgroundColor: '#f2e33c', color: '#1b5e20', boxShadow: '0 3px 8px rgba(0,0,0,0.15)' }}>
								{service.label}
							</div>
						</Link>
					))}
				</div>
			</section>

			<Footer />
		</div>
	);
};

export default Index;
